import { Redirect, Route, Switch } from 'react-router-dom';

import ProtectedRoute from 'components/routes/ProtectedRoute';
import InitialSetupPage from 'features/home/InitialSetupPage';
import ProjectSetupPage from 'features/projectSetup';
import TermsAndConditionsPage from 'features/home/TermsAndConditionsPage';
import HomePage from 'features/home/HomePage';
import ProjectsPage from 'features/projects/ProjectsPage';
import EmailVerificationPage from 'features/home/EmailVerificationPage';
import NoTags from 'features/home/NoDeveloperTag';
import ProjectDetailsPage from 'features/projectSummary';
import { Content } from 'antd/lib/layout/layout';
import ProjectSider from './components/AppLayout/Sider';
import ProjectStoreDetailsPage from 'features/storeDetails';
import BuildsPage from 'features/builds';
import BuildDetailsPage from 'features/builds/BuildDetailsPage';
import CollaboratorsPage from './features/collaborators';
import { CollaboratorPermission } from './api';
import withPermissionCheck from 'components/routes/withPermissionCheck';
import FinancePage from 'features/finance/FinancePage';
import PublishingRequirementsPage from 'features/publishingRequirements';
import InvitationPage from 'features/invitation';
import TestInvitationPage from 'features/testInvitation/TestInvitationPage';
import PlayersPage from 'features/players/PlayersPage';
import GameServicesPage from 'features/gameServices/GameServicesPage';
import AchievementsPage from 'features/gameServices/achievements/AchievementsPage';
import CreateAchievementPage from 'features/gameServices/achievements/CreateAchievementPage';
import RedemptionCodesPage from 'features/redemptionCode';
import AnalyticsPage from 'features/analytics/AnalyticsPage';
import GameStatsPage from 'features/gameServices/stats/GameStatsPage';
import CreateGameStatsPage from 'features/gameServices/stats/CreateGameStatsPage';
import EditGameStatsPage from 'features/gameServices/stats/EditGameStatsPage';
import LeaderboardsPage from 'features/gameServices/leaderboards/LeaderboardsPage';
import LeaderboardsV2Page from 'features/gameServices/leaderboardsV2/LeaderboardsPage';
import DownloadableContent from 'features/gameServices/downloadableContent/DownloadableContent';
import EditDownloadableContent from 'features/gameServices/downloadableContent/EditDownloadableContent';
import CreateLeaderboardPage from 'features/gameServices/leaderboards/CreateLeaderboardPage';
import CreateLeaderboardV2Page from 'features/gameServices/leaderboardsV2/CreateLeaderboardPage';
import EditLeaderboardPage from './features/gameServices/leaderboards/EditLeaderboardPage';
import EditLeaderboardV2Page from './features/gameServices/leaderboardsV2/EditLeaderboardPage';
import GetStartedPage from './features/getStarted/GetStartedPage';
import DownloadsPage from './features/downloads/DownloadsPage';
import SupportPage from './features/support/SupportPage';
import EditAchievementPage from 'features/gameServices/achievements/EditAchievementPage';

export default function Router() {
	return (
		<Switch>
			<Route path="/project">
				<ProjectSider />
				<Content className="page-content">
					<Switch>
						<ProtectedRoute path="/project/:projectId" exact component={ProjectDetailsPage} />
						<ProtectedRoute
							path="/project/:projectId/store-details"
							exact
							component={withPermissionCheck(ProjectStoreDetailsPage, CollaboratorPermission.StoreDetails)}
						/>
						<ProtectedRoute
							path="/project/:projectId/builds"
							exact
							component={withPermissionCheck(BuildsPage, CollaboratorPermission.Builds)}
						/>
						<ProtectedRoute
							path="/project/:projectId/builds/:releaseChannelId"
							exact
							component={withPermissionCheck(BuildDetailsPage, CollaboratorPermission.Builds)}
						/>
						<ProtectedRoute
							path="/project/:projectId/collaborators"
							exact
							component={withPermissionCheck(CollaboratorsPage, CollaboratorPermission.Collaborators)}
						/>
						<ProtectedRoute
							path="/project/:projectId/finance"
							exact
							component={withPermissionCheck(FinancePage, CollaboratorPermission.Finances)}
						/>
						<ProtectedRoute
							path="/project/:projectId/publishing-requirements"
							exact
							component={withPermissionCheck(PublishingRequirementsPage, CollaboratorPermission.Builds)}
						/>
						<ProtectedRoute
							path="/project/:projectId/analytics"
							exact
							component={withPermissionCheck(AnalyticsPage, CollaboratorPermission.Analytics)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services"
							exact
							component={withPermissionCheck(GameServicesPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/achievements"
							exact
							component={withPermissionCheck(AchievementsPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/achievements/create"
							exact
							component={withPermissionCheck(CreateAchievementPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/achievements/:apiName/edit"
							exact
							component={withPermissionCheck(EditAchievementPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/game-stats"
							exact
							component={withPermissionCheck(GameStatsPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/game-stats/create"
							exact
							component={withPermissionCheck(CreateGameStatsPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/game-stats/edit/:gameStateId/:apiName"
							exact
							component={withPermissionCheck(EditGameStatsPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/leaderboards"
							exact
							component={withPermissionCheck(LeaderboardsPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/leaderboards/create"
							exact
							component={withPermissionCheck(CreateLeaderboardPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/leaderboards/:apiName/edit"
							exact
							component={withPermissionCheck(EditLeaderboardPage, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/leaderboardsV2"
							exact
							component={withPermissionCheck(LeaderboardsV2Page, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/downloadable-content"
							exact
							component={withPermissionCheck(DownloadableContent, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/downloadable-content/edit/:id"
							exact
							component={withPermissionCheck(EditDownloadableContent, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/leaderboardsV2/create"
							exact
							component={withPermissionCheck(CreateLeaderboardV2Page, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/game-services/leaderboardsV2/:apiName/edit"
							exact
							component={withPermissionCheck(EditLeaderboardV2Page, CollaboratorPermission.GameServices)}
						/>
						<ProtectedRoute
							path="/project/:projectId/players"
							exact
							component={withPermissionCheck(PlayersPage, CollaboratorPermission.Players)}
						/>
						<ProtectedRoute
							path="/project/:projectId/redemption-codes"
							exact
							component={withPermissionCheck(RedemptionCodesPage, CollaboratorPermission.RedemptionCodes)}
						/>
					</Switch>
				</Content>
			</Route>

			<Route>
				<Content className="page-content">
					<Switch>
						<ProtectedRoute path="/initial-setup" exact component={InitialSetupPage} />
						<ProtectedRoute path="/edit-profile" exact component={InitialSetupPage} />
						<ProtectedRoute path="/toc" exact component={TermsAndConditionsPage} />
						<ProtectedRoute path="/email-verification" exact component={EmailVerificationPage} />
						<ProtectedRoute path="/no-permission" exact component={NoTags} />
						<ProtectedRoute path="/projects" exact component={ProjectsPage} />
						<ProtectedRoute path="/projectSetup" exact component={ProjectSetupPage} />
						<ProtectedRoute path="/downloads" exact component={DownloadsPage} />
						<ProtectedRoute path="/support" exact component={SupportPage} />
						<Route path="/invitation" exact component={InvitationPage} />
						<Route path="/test-invitation" exact component={TestInvitationPage} />
						<Route path="/get-started" exact component={GetStartedPage} />
						<Route path="/" exact component={HomePage} />
						<Redirect from="*" to="/" />
					</Switch>
				</Content>
			</Route>
		</Switch>
	);
}
